import { SET_MAIN_CONTENT_LOADING, SET_MAIN_CONTENT_LOADER_VISIBILITY } from '../../actions-types';

let timer;
const LOADING_DELAY = 120;

export default Object.freeze({
    setIsLoaded({ isLoaded }) {
        return (dispatch) => {
            clearTimeout(timer);
            // the loader is always in sync
            dispatch({ type: SET_MAIN_CONTENT_LOADER_VISIBILITY, isLoaderVisible: !isLoaded });

            if (isLoaded) {
                timer = setTimeout(() => dispatch({ type: SET_MAIN_CONTENT_LOADING, isLoaded }), LOADING_DELAY);
            } else {
                dispatch({ type: SET_MAIN_CONTENT_LOADING, isLoaded });
            }
        };
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/main-content/actions.js